module.exports = __webpack_public_path__ + "static/media/clientes-logo-01.220d1d65.png";